import { getAccounts, getDivisions } from './accounts.js';
import * as notifier from './notifier.js';

/**
 *
 * @param groupNum
 * @returns {function(*): Promise<unknown>}
 */
export const getDivisionTitleFilterByGroupNum = (groupNum) => async (dispatch) => {
    const result = await dispatch(getAccounts(groupNum, 0));
    if (result.accounts.length !== 1) {
        dispatch(notifier.displayError({
            code: 'NOT_FOUND',
            verbiage: 'Account not Found'
        }));

        return [];
    }

    const account = result.accounts[0];
    const divisions = await dispatch(getDivisions(account.accountID));

    return [
        'All Divisions',
        ...Object.values(divisions).map(({ title }) => title)
    ];
};